import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getPeekAMoo } from "../lib/api";
import { toast } from "sonner";

export default function PeekAMoo() {
  const { pathname } = useLocation();
  const [data, setData] = useState(null);
  const [found, setFound] = useState(false);

  useEffect(() => {
    getPeekAMoo().then(setData).catch(() => {});
  }, []);

  useEffect(() => {
    setFound(false);
  }, [pathname]);

  if (!data) return null;

  // Match by trailing path segment
  const slug = pathname.replace(/^\//, "") || "home";
  if (data.page !== slug) return null;

  const handleClick = () => {
    setFound(true);
    toast("You found Peek-a-Moo!", {
      description:
        "A little wonder for a curious heart. Well done, friend.",
      duration: 4500,
    });
  };

  return (
    <button
      onClick={handleClick}
      data-testid="peek-a-moo-icon"
      title={data.clue}
      aria-label="A hidden friend"
      className={`peek-bob absolute z-40 cursor-pointer transition-all duration-700 ${
        found ? "opacity-100 scale-110" : "opacity-70 hover:opacity-100 hover:scale-105"
      }`}
      style={{
        left: `${data.position_x}%`,
        top: `${data.position_y}%`,
        width: "78px",
        height: "78px",
        filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.35))",
      }}
    >
      <img
        src="/assets/peek-a-moo.webp"
        alt=""
        className="peek-wiggle w-full h-full object-contain select-none"
        draggable="false"
        style={{ transformOrigin: "50% 70%" }}
      />
    </button>
  );
}
